import React from 'react';
import Container from '../components/Container';
import SectionTitle from '../components/SectionTitle';

const Datenschutz = React.createClass({
    render: function() {
        return (
            <Container>
                <SectionTitle>Datenschutz</SectionTitle>
                <div className="row">
                    <div className="col-xs-12">
                        <p>
                            Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten
                            sehr ernst. Wir behandeln Ihre personenbezogenen Daten vertraulich und
                            entsprechend der gesetzlichen Datenschutzvorschriften sowie dieser
                            Datenschutzerklärung. Die Nutzung unserer Webseite ist in der Regel ohne
                            Angabe personenbezogener Daten möglich. Soweit auf unseren Seiten
                            personenbezogene Daten (beispielsweise Name, Anschrift oder
                            E-Mail-Adressen) erhoben werden, erfolgt dies, soweit möglich, stets auf
                            freiwilliger Basis. Diese Daten werden ohne Ihre ausdrückliche
                            Zustimmung nicht an Dritte weitergegeben. Wir weisen darauf hin, dass
                            die Datenübertragung im Internet (z.B. bei der Kommunikation per E-Mail)
                            Sicherheitslücken aufweisen kann. Ein lückenloser Schutz der Daten vor
                            dem Zugriff durch Dritte ist nicht möglich.
                        </p>
                        <p>
                            <h3>Personenbezogene Daten</h3>
                            Personenbezogene Daten sind Informationen, mit deren Hilfe eine Person
                            bestimmbar ist, also Angaben, die zurück zu einer Person verfolgt werden
                            können. Dazu gehören der Name, die Emailadresse oder die Telefonnummer.
                            Aber auch Daten über Vorlieben, Hobbies, Mitgliedschaften oder welche
                            Webseiten von jemandem angesehen wurden, zählen zu personenbezogenen
                            Daten. Personenbezogene Daten werden von dem Anbieter nur dann erhoben,
                            genutzt und weiter gegeben, wenn dies gesetzlich erlaubt ist oder die
                            Nutzer in die Datenerhebung einwilligen.
                        </p>
                        <p>
                            <h3>Cookies</h3>
                            Die Internetseiten verwenden teilweise so genannte Cookies. Cookies
                            richten auf Ihrem Rechner keinen Schaden an und enthalten keine Viren.
                            Cookies dienen dazu, unser Angebot nutzerfreundlicher, effektiver und
                            sicherer zu machen. Cookies sind kleine Textdateien, die auf Ihrem
                            Rechner abgelegt werden und die Ihr Browser speichert. Die meisten der
                            von uns verwendeten Cookies sind so genannte „Session-Cookies“. Sie
                            werden nach Ende Ihres Besuchs automatisch gelöscht. Andere Cookies
                            bleiben auf Ihrem Endgerät gespeichert, bis Sie diese löschen. Diese
                            Cookies ermöglichen es uns, Ihren Browser beim nächsten Besuch
                            wiederzuerkennen. Sie können Ihren Browser so einstellen, dass Sie über
                            das Setzen von Cookies informiert werden und Cookies nur im Einzelfall
                            erlauben, die Annahme von Cookies für bestimmte Fälle oder generell
                            ausschließen sowie das automatische Löschen der Cookies beim Schließen
                            des Browser aktivieren. Bei der Deaktivierung von Cookies kann die
                            Funktionalität dieser Website eingeschränkt sein.
                        </p>
                        <p>
                            <h3>Recht auf Auskunft, Löschung, Sperrung</h3>
                            Sie haben jederzeit das Recht auf unentgeltliche Auskunft über Ihre
                            gespeicherten personenbezogenen Daten, deren Herkunft und Empfänger und
                            den Zweck der Datenverarbeitung sowie ein Recht auf Berichtigung,
                            Sperrung oder Löschung dieser Daten. Hierzu sowie zu weiteren Fragen zum
                            Thema personenbezogene Daten können Sie sich jederzeit unter der im
                            Impressum angegebenen Adresse an uns wenden.
                        </p>
                        <p>
                            <h3>Cookie Banner</h3>
                            Zur Darstellung des Cookie Banners auf der Webseite werden durch Ihren
                            Browser die benötigten Daten von cookies.mplg.info (Marktplatz GmbH -
                            Agentur für Web & App) geladen. Es werden keine Daten von Ihnen
                            gespeichert.
                        </p>
                        <p>
                            <h3>Matomo (Piwik)</h3>
                            <br />
                            Diese Website benutzt den Open Source Webanalysedienst Matomo. Matomo
                            verwendet so genannte „Cookies“. Das sind Textdateien, die auf Ihrem
                            Computer gespeichert werden und die eine Analyse der Benutzung der
                            Website durch Sie ermöglichen. Dazu werden die durch den Cookie
                            erzeugten Informationen über die Benutzung dieser Website auf unserem
                            Server gespeichert. Die IP-Adresse wird vor der Speicherung
                            anonymisiert.
                        </p>
                        <p>
                            Die durch den Cookie erzeugten Informationen über die Benutzung dieser
                            Website werden nicht an Dritte weitergegeben. Sie können die Speicherung
                            der Cookies durch eine entsprechende Einstellung Ihrer Browser-Software
                            verhindern; wir weisen Sie jedoch darauf hin, dass Sie in diesem Fall
                            gegebenenfalls nicht sämtliche Funktionen dieser Website vollumfänglich
                            werden nutzen können.
                        </p>
                        <p>
                            Wenn Sie mit der Speicherung und Nutzung Ihrer Daten nicht einverstanden
                            sind, können Sie die Speicherung und Nutzung hier deaktivieren. In
                            diesem Fall wird in Ihrem Browser ein Opt-Out-Cookie hinterlegt, der
                            verhindert, dass Matomo Nutzungsdaten speichert. Wenn Sie Ihre Cookies
                            löschen, hat dies zur Folge, dass auch das Matomo Opt-Out-Cookie
                            gelöscht wird. Das Opt-Out muss bei einem erneuten Besuch unserer Seite
                            wieder aktiviert werden.
                        </p>
                        <p>
                            <iframe
                                style={{ border: 0 }}
                                src="//mplg.info/statistikcenter-allg/index.php?module=CoreAdminHome&amp;action=optOut&amp;language=de"
                                width="100%"
                                height="auto"
                            />
                        </p>
                        <p>
                            Quelle:{' '}
                            <a href="https://www.e-recht24.de/">https://www.e-recht24.de/</a>
                        </p>
                    </div>
                </div>
            </Container>
        );
    }
});

export default Datenschutz;



// WEBPACK FOOTER //
// ./src/js/containers/Datenschutz.js